import React, { useState } from 'react'
import { Drawer, Tabs, DatePicker, Menu, Dropdown, Badge } from 'antd'
import Select from '@atlaskit/select'
import ReactSelect from 'react-select'
import { useHistory, useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { AiOutlineDown } from 'react-icons/ai'

import { normalize, patientName, stringifyDate, useListData, usePet, useToggle } from '../../modules'

import Receive from '../reusable/receive'
import WriteInstructions from '../modals/writeInstructions'
import pluralize from 'pluralize'
import PreauthCheck from '../modals/preauthCheck'

const { TabPane } = Tabs
const { RangePicker } = DatePicker

const RequestItems = ({ patient, inPatient = false, attachedTo, groups, source, tab: tb = "1" }) => {
    let group = 'Non-Medical Billed Items'

    let { categories } = groups.find(grp => grp.name === group) ?? { categories: [] }

    const [ranges, setRanges] = useState()
    const [cat, setCat] = useState({ label: 'All', value: 'All' })
    const [selected, setSelected] = useState([])
    const [index, setIndex] = useState()
    const [string, setString] = useState()
    const [sString, setSString] = useState()
    const [tab, setTab] = useState(tb)
    const [preauthIndex, setPreauthIndex] = useState(null)

    const { id } = useParams()
    const history = useHistory()

    const { user } = useSelector(state => state.application)

    const [visible, toggleVisible] = useToggle(true)
    const [includeOthers, toggleOthers] = useToggle()
    const [instructions, toggleInstructions] = useToggle(true)
    const [preauthVisible, , setPreauthVisible] = useToggle()
    const [select, 
        // toggleSelect
    ] = useToggle()

    const close = () => {
        toggleVisible()
        console.log(source)
        setTimeout(() => history.goBack(), 300)
    }

    const saveInstructions = (ins, i) => {
        let temp = [...selected]
        temp[i].instructions = ins
        setSelected(temp)
    }

    const [
        { loading: iLoading, fetch: fetchItems },
        { list: items },
        { page = 1, limit = 10 }
    ] = useListData('saleItems', { string, category: cat.label, group }, { notify: true }, 'items')

    const [
        { loading: itLoading, error: itError, fetch: fetchBillItems },
        { list: billItems, count = 0 },
        { page: itPage = 1, limit: itLimit = 10, navigate, Paginate }
    ] = useListData('billedItems', ranges ? { 
        patient: patient?._id,
        string: sString, 
        attachedTo: includeOthers ? undefined : attachedTo?._id,
        group,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null
    } : { string: sString, attachedTo: includeOthers ? undefined : attachedTo?._id, group, patient: patient?._id, }, { notify: true }, 'items')

    const refresh = () => {
        navigate(1)
        fetchBillItems()
    }

    const onComplete = (_, notif, ops) => {
        notif(`Request${selected?.length > 1 ? 's' : '' } for the specified items ${selected?.length > 1 ? 'have' : 'has' } been sent`, ops('success'))
        clear()
        refresh()
        setTab("1")
    }

    const [{ loading: bLoading }, billPatient] = usePet('billPatient', {
        patient: patient?._id,
        attachedTo,
        inPatient,
        items: selected.map(({ _id, quantity, price, instructions, preauth }) => ({
            item: _id,
            quantity,
            instructions,
            price,
            preauth: preauth?._id ?? preauth,
        })),
        station: localStorage.getItem('station') ?? 'Cashier'
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Adding items to bill...' } })

    const searchSent = str => {
        if (str?.trim()?.length > 2 || !str) {
            setSString(str)
            refresh()
        }  
    }

    const search = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            fetchItems()
        }  
    }

    const onCategoryChange = ct => {
        setCat(ct)
        fetchItems()
    }

    const modifyQty = (i, val) => {
        let temp = [...selected]
        temp[i].quantity += val

        if (temp[i].quantity <= 0)
            temp = temp.filter((_, k) => k !== i)

        setSelected(temp)
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const clear = () => setSelected([])

    const selectOthers = () => {
        toggleOthers()
        refresh()
    }

    const sendPatient = () => {
        const nextIndex = selected.findIndex(item => item?.preauthRequired && item?.preauthCategory && !item?.preauth)
        if (nextIndex < 0) return billPatient()

        setPreauthIndex(nextIndex)
        setPreauthVisible(true)
    }

    const attachPreauth = preauth => {
        let temp = [...selected]
        temp[preauthIndex].preauth = preauth
        setSelected(temp)
        setPreauthVisible(false)
        setPreauthIndex(null)

        setTimeout(() => {
            const nextIndex = temp.findIndex(item => item?.preauthRequired && item?.preauthCategory && !item?.preauth)
            if (nextIndex < 0) billPatient()
            else {
                setPreauthIndex(nextIndex)
                setPreauthVisible(true)
            }
        }, 100)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ sendPatient } className="text-white hisani-btn-orange mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Send Patient</button>
                    <button onClick={ clear } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Clear Items</button>
                </div>
            }
            width={800}>
            <p className="font-extrabold text-3xl mb-0">Request Items</p>
            {
                index >= 0 &&
                <WriteInstructions
                    selected={ index }
                    onClose={ setIndex }
                    onSave={ saveInstructions }
                    pre={ selected[index]?.instructions }
                    visible={ instructions }
                    toggle={ toggleInstructions } />
            }
            {
                preauthVisible &&
                <PreauthCheck
                    visible={ preauthVisible }
                    toggle={ () => {
                        setPreauthVisible(false)
                        setPreauthIndex(null)
                    } }
                    patient={ patient }
                    saleItem={ preauthIndex >= 0 ? selected[preauthIndex] : null }
                    onCreated={ () => {
                        setPreauthVisible(false)
                        setPreauthIndex(null)
                    } }
                    onProceed={ attachPreauth } />
            }
            <Tabs onChange={ setTab } activeKey={ tab }>
                <TabPane key="0" tab="Send New">
                    <div className="w-full md:w-1/2 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Select category
                        </label>
                        <Select
                            inputId="single-select-example"
                            className="single-select"
                            classNamePrefix="react-select"
                            onChange={ onCategoryChange }
                            value={ cat }
                            options={ ['All', ...categories].map(cat => ({ label: cat, value: cat })) }
                            placeholder="Choose Category" />
                    </div>
                    <div className="w-full my-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Request Items
                        </label>
                        <ReactSelect
                            isMulti
                            onInputChange={search}
                            onChange={ setSelected }
                            value={ selected }
                            isLoading={ iLoading }
                            styles={{
                                option: (styles, { data }) => { 
                                    let { current } = data
                                    return {
                                        ...styles, 
                                        backgroundColor: current <= 0 ? undefined : styles.backgroundColor,
                                        color: current <= 0 ? 'gray' : styles.color,
                                        cursor: current <= 0 ? 'not-allowed' : 'default'
                                    }
                                }
                            }}
                            options={ items?.map(itm => ({ label: `${itm.name}${itm.current <= 0 ? ` - Ksh. ${itm.price} (Out of Stock)` : '' }`, value: itm._id, ...itm, quantity: 1, isDisabled: itm?.current <= 0 })) }
                            placeholder={ `What items is ${patientName(patient?.name) } being sent for?` } />
                    </div>
                    <div className="p-3 mt-4">
                        {
                            selected.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Item</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Quantity</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Unit Price</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Total</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                selected.map((item, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + (key + 1)}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ item.name }</div>
                                                        </td>
                                                        <td className="p-2 flex items-center justify-center">
                                                            <button onClick={() => modifyQty(key, -1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">-</button>
                                                            <span className="text-center px-3">{ item.quantity }</span>
                                                            <button onClick={() => modifyQty(key, 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">+</button>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">Ksh. { item.price }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">Ksh. { item.price * item.quantity }</div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    <div className="flex flex-col items-end mb-3 p-3">
                                        <p className="font-semibold text-lg underline mb-2">Total Selected</p>
                                        <p>Total: Ksh. { normalize(selected.reduce((total, itm) => total + (itm.price * itm.quantity), 0)) }</p>
                                    </div>
                                </div>
                                :
                                <div className="w-full h-16 mt-4 flex items-center justify-center">
                                    <p className="font-semibold text-base">You can add items by selecting from the list above</p>
                                </div>
                        }
                    </div>
                </TabPane>
                <TabPane key="1" tab={ <Badge count={ count }>Previous Items</Badge> }>
                    <div className="sm:flex sm:justify-between sm:items-center mb-2">
                        <span>
                            <input
                                onChange={e => searchSent(e.target.value)}
                                className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Search for item" />
                            <span>
                                <input
                                    onChange={ selectOthers }
                                    checked={ includeOthers }
                                    type="checkbox"
                                    className="form-checkbox cursor-pointer h-5 w-5" />
                                <span onClick={ selectOthers } className="text-gray-500 cursor-pointer text-xs italic ml-2">Show requested items from outside this period</span>
                            </span>
                        </span>
                        {
                            includeOthers &&
                            <RangePicker onChange={selectRange} />
                        }
                    </div>
                    <div className="">
                        <Receive
                            progress
                            loading={itLoading}
                            error={itError}>
                            {
                                billItems.length > 0 ?
                                    <div className="overflow-x-auto">
                                        <table className="table-auto w-full">
                                            {/* Table header */}
                                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                <tr>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-center">No</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Item</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Sent By</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-center"></div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            {/* Table body */}
                                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                {
                                                    billItems.map((item, key) =>
                                                        <tr>
                                                            <td className="p-2">
                                                                <div className="text-center">{((itPage - 1) * itLimit) + (key + 1)}.</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="">{ item.name } { item.quantity > 1 && ` (x ${item.quantity})` }</div>
                                                                <p className="text-gray-500 my-0 text-xs italic">Sent On { stringifyDate(item.date) }</p>
                                                                <p className={ `text-${ item.cancelled ? 'gray' : item.seen ? 'green' : 'yellow'}-500 mt-0 text-xs italic mb-0` }>{ item.cancelled ? 'Cancelled' : item.seen ? 'Seen' : 'Pending' }</p>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="">{ item.sentBy?.name }</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <Dropdown
                                                                    overlay={
                                                                        <Menu>
                                                                            <Menu.Item onClick={ () => null }>View</Menu.Item>
                                                                            {
                                                                                !item.seen && (item.sentBy._id === user?._id || user?.issuperuser) &&
                                                                                <>
                                                                                    <Menu.Item onClick={ () => null }>Edit</Menu.Item>  
                                                                                    <Menu.Item onClick={ () => null }>Delete</Menu.Item>  
                                                                                </>
                                                                            }
                                                                        </Menu>
                                                                    }>
                                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    :
                                    <div className="w-full h-16 mt-4 flex items-center justify-center">
                                        <p className="font-semibold text-base">No requests were made for {patientName(patient?.name)}</p>
                                    </div>
                            }
                        </Receive>
                        { Paginate }
                    </div>
                </TabPane>
            </Tabs>
        </Drawer>
    )
}

export default RequestItems
